<div nxModalContent>
  <div nxLayout="grid nopadding">
    <div nxRow class="nx-margin-bottom-s">
      <div nxCol="12" #formField>
        <h3 nxHeadline="subsection-medium" class="nx-margin-bottom-m nx-font-weight-light">Make / Model</h3>
        <div nxLayout="grid nopadding">
          <div nxRow>
            <div nxCol="12">
              <div [formGroup]="searchModelForm">
                <div class="make_model_search">
                  <nx-formfield>
                    <input nxInput formControlName="searchBy" placeholder="{{ 'COVERAGE.FIELD.MAKE_MODEL_KEYWORD' | translate }}" appToUpperCase (keydown.enter)="onSearchClicked()" />
                    <span nxFormfieldPrefix>
                      <nx-icon name="search" size="s" class="make_model_icon"></nx-icon>
                    </span>
                    @if (searchBy.value) {
                      <span nxFormfieldSuffix aria-hidden="true" (click)="clearSearch()">
                        <nx-icon name="close" size="s" class="make_model_icon"></nx-icon>
                      </span>
                    }
                    @if (searchModelForm.get("searchBy").errors) {
                      <nx-error nxFormfieldError>
                        <strong>{{ "COMMON.FIELD.REQUIRED" | translate: { labelName: "COVERAGE.FIELD.MAKE_MODEL" | translate } }}</strong>
                      </nx-error>
                    }
                  </nx-formfield>
                  <div>
                    <button nxButton (click)="onSearchClicked()">{{ "GLOBAL.ACTION.SEARCH" | translate }}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="searchPerformed" class="nx-margin-bottom-4m">
      @if (searchPerformed) {
        <div nxRow>
          <div nxCol="12">
            <div class="test_table table_popup">
              <div class="table-container nx-margin-top-s">
                <app-external-scrollbar targetSyncScroll="1" [targetBaseWidth]="tableHolder" [style.display]="toggle_overflow ? 'block' : 'none'"></app-external-scrollbar>
                <div class="table-holder table_content_scroll_test only-this-horizon-scrollbar" #tableHolder syncScroll="1" [style.overflow-x]="toggle_overflow ? 'auto' : 'unset'">
                  <table nxTable zebra class="make_model_table">
                    <thead>
                      <tr nxTableRow>
                        <th nxHeaderCell>Make / Model</th>
                        <th nxHeaderCell class="variant">Variant</th>
                        <th nxHeaderCell class="std-ta-right">
                          <span class="text_no_wrap">Sum Insured <br />Range (RM)</span>
                        </th>
                        <th nxHeaderCell>Engine Type</th>
                        <th nxHeaderCell>Capacity</th>
                        <th nxHeaderCell>Seats</th>
                        <th nxHeaderCell>Code</th>
                      </tr>
                    </thead>
                    <tbody>
                      @if (searchMakeModelList.length) {
                        <tr nxTableRow *ngFor="let item of paginatedResults; let i = index" (select)="select(item)" [selectable]="true">
                          <td nxTableCell>{{ item.piamMakeCodeDesc }} {{ item.piamModelCodeDesc }}</td>
                          <td nxTableCell>
                            <div class="variant">
                              {{ item.variantFullDesc }}
                            </div>
                          </td>
                          <td nxTableCell class="std-ta-right">
                            <div class="sum_insured">
                              @if (data.region === "E") {
                                {{ item.avEmSiMin | number: "1.0" : "en-US" }} - {{ item.avEmSiMax | number: "1.0" : "en-US" }}
                              }
                              @if (data.region === "W") {
                                {{ item.avWmSiMin | number: "1.0" : "en-US" }} - {{ item.avWmSiMax | number: "1.0" : "en-US" }}
                              }
                            </div>
                          </td>
                          <td nxTableCell>{{ item.engineType }}</td>
                          <td nxTableCell>{{ item.capacity | number: "1.0" : "en-US" }}</td>
                          <td nxTableCell>{{ item.seat }}</td>
                          <td nxTableCell>{{ item.vehModelCodeNvic }}</td>
                        </tr>
                      }
                      @else {
                        <tr nxTableRow>
                          <td nxTableCell colspan="7" class="std-ta-center">NO DATA</td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      <form [formGroup]="pageFilterForm" class="navigation">
        <div nxLayout="grid nopadding" class="nx-margin-top-2xs grid_remove_padding pagination_form">
          @if (showPagination && getResultLength() > 10) {
            <div nxRow>
              <div nxCol="12,12,6" class="nx-hidden-xs nx-hidden-s">
                <nx-natural-language-form size="small" class="pagination_form">
                  <span nxCopytext="normal">Show</span>
                  <nx-word>
                    <nx-dropdown formControlName="perPage" [panelGrow]="true" [panelMaxWidth]="500" [value]="perPage">
                      <nx-dropdown-item *ngFor="let item of itemsPerPageSelections" [value]="item"></nx-dropdown-item>
                    </nx-dropdown>
                  </nx-word>
                  <span nxCopytext="normal">results per page</span>
                </nx-natural-language-form>
              </div>
              <div class="nx-margin-xs margin-box nx-hidden-m nx-hidden-l nx-hidden-xl nx-hidden-2xl nx-hidden-3xl"></div>
              @if (getResultLength() > 10) {
                <div nxCol="12,12,6">
                  <nx-pagination [count]="getResultLength()" [page]="curpage" [perPage]="perPage" type="advanced" class="pagination_position" (goPrev)="prevPage()" (goNext)="nextPage()" (goPage)="goToPage($event)"></nx-pagination>
                </div>
              }
            </div>
          }
        </div>
      </form>
    </div>
    <div nxRow class="nx-margin-top-s">
      <div nxCol="12">
        <button nxButton="secondary" (click)="removeValidation()" nxModalClose>Cancel</button>
      </div>
    </div>
  </div>
</div>
